<template>
    <div>
        <Modal @onConfirm="onConfirm" 
            @onClose="onClose" 
            :isDisabled="confirmDisabled" 
            :isOpen="isOpen" 
            :modalTitle="currentPosition.name" 
            :confirmLabel="$t('modules.positions.index.sendReportModal.confirmLabel')"
            class="send_reports_modal">

            <SendReportEvalChoice @evalChoiceChanged="handleEvalChoices" @goStep2="isStep1 = false" v-if="isStep1" />
            <SendReportEmailForm @dataValid="getEmailData" @dataInvalid="confirmDisabled = true" v-else  />
    
        </Modal>
    </div>
</template>

<script>
import SendReportEvalChoice from './sendReportEvalChoice'
import SendReportEmailForm from './sendReportEmailForm'

export default {
    name: 'SendReportModal',
    props: ['opened'],
    components: {
        SendReportEvalChoice,
        SendReportEmailForm
    },
    data(){
        return {
            isOpen: false,
            confirmDisabled: true,
            isLoading: false,
            isStep1: true,
            emailData: {}
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        }
    },
    methods: {
        handleEvalChoices(evalList, reportType){
            console.log(evalList, reportType)
            this.emailData.evaluations = this._.map(evalList, 'id')
            this.emailData.report_type = reportType
            
        },
        onConfirm(){
            this.emailData.sight_group_id = this.currentPosition.id
            this.isLoading = true
            this.$store.dispatch('PositionStore/sendReportsEmails', this.emailData).then( () => {
                this.$emit('sendReportSuccess')
                this.$emit('closeSendReport')
                this.isOpen = false
                this.isLoading = false
                this.isStep1 = true
            })
        },
        onClose(){
            this.isOpen = false
            this.$emit('closeSendReport')
            this.confirmDisabled = true
            this.isStep1 = true
        },
        getEmailData(sendTo, message){
            this.emailData.send_to = sendTo
            this.emailData.message = message
            this.confirmDisabled = false
        }

    },
    watch: {
        'opened': {
            handler: function(newVal, oldVal){
                this.isOpen = newVal
            }
        }
    }
}
</script>

<style lang="scss" >
    .send_reports_modal{
        text-align: left;
        .modal-card{
            width: 100%;
            max-width: 800px;
        }
    }
</style>